import { QuestionTooltip } from "./QuestionTooltip";
import { MonthSelectorQuestion as MonthSelectorQuestionType } from "./questionTypes";
import { cn } from "@/lib/utils";

const MONTHS = [
  { value: "january", label: "January" },
  { value: "february", label: "February" },
  { value: "march", label: "March" },
  { value: "april", label: "April" },
  { value: "may", label: "May" },
  { value: "june", label: "June" },
  { value: "july", label: "July" },
  { value: "august", label: "August" },
  { value: "september", label: "September" },
  { value: "october", label: "October" },
  { value: "november", label: "November" },
  { value: "december", label: "December" },
];

interface MonthSelectorQuestionProps {
  question: MonthSelectorQuestionType;
  value: string;
  onChange: (questionId: string, value: string) => void;
}

export function MonthSelectorQuestion({ question, value, onChange }: MonthSelectorQuestionProps) {
  return (
    <div className="space-y-8 w-full max-w-4xl mr-auto py-4 min-h-[400px] text-left">
      <div>
        <h2 className="text-2xl font-bold text-foreground mb-3">
          {question.title}
          {question.tooltip && <QuestionTooltip tooltip={question.tooltip} />}
        </h2>
        {question.description && <p className="text-muted-foreground">{question.description}</p>}
      </div>

      <div className="grid grid-cols-3 sm:grid-cols-4 gap-3 max-w-2xl">
        {MONTHS.map((month) => (
          <button
            key={month.value}
            type="button"
            onClick={() => onChange(question.id, month.value)}
            className={cn(
              "p-3 border rounded-md text-sm font-medium transition-all cursor-pointer text-center",
              "hover:border-primary hover:bg-muted/50",
              value === month.value
                ? "border-primary bg-primary/10 text-primary"
                : "border-border text-foreground"
            )}
          >
            {month.label}
          </button>
        ))}
      </div>
    </div>
  );
}
